import './Locations.css';

function SouthLake() {
  return (
    <div className="SouthLake">
      <h3>South Lake Tahoe</h3>
      
      <p>The interior of the car smells of spaghetti. Cyane looks hungrily at the culprit: 
        take-out Italian in warm foil pans, steam rising deliciously from their tops and 
        fogging up the passenger window. Cyane chews on her seat belt, letting saliva wet 
        the fabric fully before sucking back the spit with fervor. Her dad sits up front, 
        slowly navigating the winding icy road along the side of the lake while humming 
        along to their favorite opera, The Magic Flute.</p>

      <p>Cyane looks outside her window, out upon the inky black lake surrounded by 
        dark mountains. It is a clear night, and she can see the twinkling lights of 
        small towns clustered around the shore. The moon, full and fat, hangs heavily 
        like a spotlight over the center of the lake, illuminating the caps of the wind 
        waves that splash against the frosted boulders rimming this portion of the waterside.</p>

      <p>Cyane tells the moon it will be her friend.</p>

      <p>The face in the moon sharpens and its eye winks.</p>

      <p>Cyane presses her face against the window, her quick breaths fogging up the 
        glass. Outside, swirls of snow emerge from the forest, leaping alongside the 
        car. They must hear the opera music, as they laugh and tumble in time with the 
        orchestra. One stays close to Cyane’s window, her eyes sparkling in the moonlight,
         long hair streaming behind her in the wind. She smiles. Cyane smiles back.</p>

      <p>The beginning notes of the Queen of the Night aria creep into the thick marinara 
        air with trembling bowstrings, before the horns rip into the car with a jarring blast. 
        Cyane starts, then leans forward to anxiously tap her father’s shoulder.</p>

      <p>“Up! Up!”</p>

      <p>The beginning notes of the Queen of the Night aria creep into the thick marinara 
        air with trembling bowstrings, before the horns rip into the car with a jarring blast. 
        Cyane starts, then leans forward to anxiously tap her father’s shoulder.</p>
      
      <p><i>Will I see you again?</i></p>
      <p><i>Of course.</i></p>
    </div>
  );
}

export default SouthLake;
